import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CompareView } from 'widgets/settings-master/ui/compare-view';
import { pathSpec } from 'entities/settings-master/model/path';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { StepperComponent } from 'shared/components/dialogs/router/stepper';
import { useNavigateRoot } from 'shared/hooks/router';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { SettingsMasterContext } from 'widgets/settings-master/model/context/type';
export const DialogView = memo(function SimOrderCompare() {
    const onClose = useNavigateRoot();
    const { boardId } = useParams();
    const { typeDeviceForMasterSettings } = useContext(SettingsMasterContext);
    const steps = Object.entries(pathSpec[typeDeviceForMasterSettings]).map(([id, { title }]) => ({
        id: parseInt(id, 10),
        name: title,
    }));
    const current_step_id = steps.findIndex(({ id }) => id == parseInt(boardId ?? '0', 10)) ?? 0;
    return (_jsxs(ErrorBoundary, { children: [_jsx(CompareView, { onClose: onClose }), isMediumUI() && (_jsx(StepperComponent, { step_id: current_step_id, steps: steps }))] }));
});
